import Swiper from 'swiper';

const quickLinks = () => ({
  cacheNodes() {
    this.swiperEl = this.$el.querySelector('.swiper');
  },

  buildSwiper() {
    if (!this.swiperEl) {
      return;
    }

    this.swiperInstance = new Swiper(this.swiperEl, {
      slidesPerView: 'auto',
    });
  },

  onShopifyBlockSelect({ event }) {
    const index = event.target?.dataset?.slideIndex;

    if (this.swiperInstance && typeof index !== 'undefined') {
      this.swiperInstance.slideTo(Number(index), 0);
    }
  },

  init() {
    this.cacheNodes();
    this.buildSwiper();
  },
});

export default quickLinks;
